import * as React from "react";
import { forwardRef } from "react";
const SvgColorSquare = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 12", ref, ...props }, /* @__PURE__ */ React.createElement("rect", { width: 10, height: 10, x: 1, y: 1, fill: "var(--color)", rx: 3 }));
const ForwardRef = forwardRef(SvgColorSquare);
export { ForwardRef as ReactComponent };
